'use client'
import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Text from '@mui/material/Typography'
import { BlogpostSlicedDocumentDataBodyImageSlice } from '@root/prismicio-types'
import Image from 'next/image'

export const BlogImage = ({ slice }: { slice: BlogpostSlicedDocumentDataBodyImageSlice }) => {
    const theme = LuneTheme

    const {
        image,
        size,
        attribution_caption: attributionCaption,
        attribution_url: attributionUrl,
    } = slice.primary
    const my = {
        xs: 8,
        sm: 15,
        md: 15,
        lg: 15,
        xl: 15,
    }

    const sx = {
        mb: my,
        mt: size === 'title' ? 0 : my,
        ...(size === 'column' && { maxWidth: '720px' }),
    }

    const StyleWrapper = ({
        respectPageMargins,
        children,
    }: {
        respectPageMargins: boolean
        children: React.ReactChild
    }) => {
        if (respectPageMargins) {
            return (
                <Container
                    maxWidth="xl"
                    sx={{
                        paddingLeft: '0px',
                        paddingRight: '0px',
                    }}
                >
                    <Box
                        px={{
                            xs: 0,
                            sm: 6,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        }}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        {children}
                    </Box>
                </Container>
            )
        }
        return <>{children}</>
    }

    return (
        <StyleWrapper respectPageMargins={size !== 'full-bleed'}>
            <Box
                sx={{
                    width: '100%',
                    ...sx,
                }}
            >
                <Image
                    src={image.url!}
                    alt={image.alt || 'image'}
                    width={image.dimensions?.width}
                    height={image.dimensions?.height}
                    style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                    }}
                />
                {attributionCaption && (
                    <Text
                        sx={{
                            position: `relative`,
                            top: `${theme.spacing(2)}`,
                            color: `${(theme.palette as any).Grey600}`,
                            left: `${size === 'full-bleed' ? theme.spacing(3) : 0}`,
                        }}
                        variant={`caption`}
                    >
                        {attributionUrl ? (
                            <a
                                style={{
                                    color: `${(theme.palette as any).Grey600}`,
                                    textDecoration: `none`,
                                }}
                                href={attributionUrl}
                            >
                                {attributionCaption}
                            </a>
                        ) : (
                            attributionCaption
                        )}
                    </Text>
                )}
            </Box>
        </StyleWrapper>
    )
}
